import * as React from "react";

/** Linienicons wie in den Refined-Flächen, ohne Komponentenbibliothek. */
export function OfficeOpenIcon({ kind, size = 20 }: {
  kind: "web" | "desktop" | "document" | "history" | "close";
  size?: number;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"
      strokeLinejoin="round" aria-hidden="true" focusable="false">
      {kind === "web" && <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3c-4 5-4 13 0 18M12 3c4 5 4 13 0 18" />
      </>}
      {kind === "desktop" && <>
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <path d="M8 21h8M12 16v5" />
      </>}
      {kind === "document" && <>
        <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Zm0 0v6h6M8 13h8M8 17h6" />
      </>}
      {kind === "history" && <>
        <path d="M3 10a9 9 0 1 1 2.6 8.4M3 4v6h6M12 7v5l3 2" />
      </>}
      {kind === "close" && <path d="m6 6 12 12M18 6 6 18" />}
    </svg>
  );
}
